import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper from "swiper/bundle";
import "swiper/css";

window.addEventListener('DOMContentLoaded', () => {
    // Works Carousel
    const workCarousel = new Swiper(".works-carousel", {
        slidesPerView: 1.5,
        centeredSlides: true,
        initialSlide: 1,
        loop: false,
        spaceBetween: 40,
        speed: 1000,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'opacity-50 pointer-events-none',
            hiddenClass: 'swiper-button-hidden',
            navigationDisabledClass: 'swiper-nav-disabled',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 60,
                initialSlide: 0,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 80,
            },
            1536: {
                slidesPerView: 4,
                spaceBetween: 120,
            },
        },
    });

    const worksParent = document.querySelector("#works-animation");

    if (worksParent) {
        // workCarousel.disable();
        const carouselWrapper = worksParent.querySelector("#works-carousel-wrapper");
        const title = worksParent.querySelector("#works-title");
        const verticalOffset = 1.25 * 16 + title?.clientHeight + parseFloat(window.getComputedStyle(worksParent).getPropertyValue("padding-top"));
        let scaleAnimation = null;
        scaleAnimation = gsap.from(carouselWrapper, {
            y: -verticalOffset,
            scale: window.innerWidth >= 1536 ? 0.1 : 0.2,
            scrollTrigger: {
                trigger: worksParent,
                start: "top-=35% top",
                end: () => `+=${verticalOffset}px`,
                scrub: true,
            },
            onUpdate: () => {
                if (scaleAnimation) {
                    const progress = scaleAnimation.progress();
                    if (progress > 0.8) {
                        carouselWrapper.classList.add("ready");
                        carouselWrapper.classList.remove("pointer-events-none");
                        // workCarousel.enable();
                    } else {
                        carouselWrapper.classList.remove("ready");
                        carouselWrapper.classList.add("pointer-events-none");
                        // workCarousel.disable();
                    }
                }
            },
        });

        gsap.from(carouselWrapper.querySelectorAll(".swiper-slide"), {
            rotate: 0,
            paddingTop: 0,
            paddingBottom: 0,
            scrollTrigger: {
                trigger: worksParent,
                start: "top-=200px top",
                end: () => `+=${verticalOffset}px`,
                scrub: true,
            },
        });
    }

    const jobsCarouselParent = document.querySelectorAll('.jobs-carousel');
    
    if (jobsCarouselParent) {
        jobsCarouselParent.forEach(slider => {
            const jobsCarousel = new Swiper(slider, {
                slidesPerView: 1.3,
                spaceBetween: 30,
                centeredSlides: true,
                loop: false,
                initialSlide: 0,
                watchOverflow: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    disabledClass: 'opacity-50 pointer-events-none',
                    hiddenClass: 'swiper-button-hidden',
                    navigationDisabledClass: 'swiper-nav-disabled',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.25,
                        spaceBetween: 80,
                        initialSlide: 0,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 80,
                        initialSlide: 0,
                    }
                }
            })
        })
    }
})
